export default {
  pwmat: {
    title: '简介',
    intrP1: `
    PWmat是原子尺度方面的材料模拟软件包，它基于第一性原理，利用平面波基组、赝势方法进行电子结构计算、分子动力学模拟。
    更重要的是，PWmat使用CUDA进行GPU优化加速，相比相同的CPU软件（PEtot，基于BSD开源授权），
    达到了20倍的加速，能够在MSTATION上面实现4000电子以上体系的模拟计算。`,
    intrP2: 'PWmat能够近似求解多体薛定谔方程得到体系的电子态和能量。在密度泛函理论（DFT）框架内，利用局域密度近似（LDA）、广义梯度近似（GGA）、混合泛函（HSE）近似等方法求解Kohn-Sham方程。',
    intrP3: 'PWmat中的单电子轨道、电子密度、局域势都利用平面波基组展开，电子-离子相互作用通过模守恒赝势或者超软赝势来描述。',
    feature: '功能特点',
    fun01name: '交换关联泛函',
    fun01desc1: '混合泛函',
    fun02name: '构弛豫与分子动力学',
    fun02desc1: '晶格和原子弛豫',
    fun02desc2: '第一性',
    fun03name: '磁性计算',
    fun03desc1: '线性与非线性磁性计算',
    fun03desc2: '自旋轨道耦合',
    fun04name: '力学性质',
    fun04desc1: '材料状态方程',
    fun04desc2: '材料声子谱',
    fun05name: '电子结构',
    fun05desc1: '能带结构与电子态密度',
    fun05desc2: '电荷密度分布',
    fun06name: '兼容 PWSCF',
    fun06desc1: '方程',
    fun07desc1: '即时含时密度泛函模拟',
    fun07desc2: '飞秒级分子动力学加速',
    fun08name: '电声耦合计算',
    fun08desc1: '全新算法描述电子态相互作用',
    fun09name: 'solvent溶剂效应',
    fun09desc1: '各种液态气态溶剂效应',
    fun09desc2: '相比传统算法，10倍加速',
    app: '应用',
    appP1: `PWmat能够用来解决如下一些问题，这些应用一部分可以直接通过PWmat计算得到，
    一部分需要基于PWmat的计算结果来分析，而所有这些应用仅依赖于PWmat的核心功能（SCF、NONSCF、DOS、RELAX、MD、NEB）`,
    appR1C1: '晶体能带结构',
    appR2C1: '电子态密度（DOS）',
    appR3C1: '晶体化合物的形成能',
    appR4C1: '合金相图',
    appR5C1: '声子谱',
    appR6C1: '缺陷形成能和缺陷分析',
    appR7C1: '表面重构与表面能',
    appR8C1: '分子在表面的吸附与结构',
    appR9C1: '能带修正',
    appR10C1: '超晶格结构模拟',

    appR1C2: '量子阱效应',
    appR2C2: '液体自由能',
    appR3C2: '分子或者离子在液体中的扩散',
    appR4C2: '团簇结构搜索',
    appR5C2: '晶体结构搜索',
    appR6C2: '固体热导率',
    appR7C2: '催化反应与中间态',
    appR8C2: '化学反应路径与反应能量',
    appR9C2: '有机物分子结构',
    appR10C2: '光学性质计算',

    test: '性能测试',
    testSpeed: '速度测试',
    testAccuracy: '精度测试',

    allinone: '一体化解决方案',

    try: '软件试用',
    tryApply: '申请 License 试用',
    tryMcloud: '注册超算云 Mcloud 试用',

    tutor: '软件教程',
    tutorStart: '快速上手教程',
    tutors: '教程',
    tutorCase: '案例教程',
    tutorVideo: '视频教程',

    link: '相关链接',
    download: '下载',
    potentialDownload: '赝势下载',
    enDownload: '英文手册下载',
    zhDownload: '中文手册下载',
    paper: '发表论文',
  }
}